import getColor from '~/lib/getColor'

export const UPDATED_HTS_TERM_TITLE = 'Overseas Shipping Terms'
export const BORDER = `1px solid ${getColor('blackAlpha15')}`
export const INTERNATIONAL_SHIPPING_REQUIREMENT =
    ' https://help.fictiv.com/en/articles/3413162-guide-to-international-shipping-requirements'
